<template>
  <base-info-card title="Recent Articles">
    <v-list class="py-0">
      <template v-for="(article, i) in articles">
        <v-list-item
          :key="i"
          class="px-0"
          three-line
          :to="article.slug ? { name: 'BlogArticle', params: { lang: $i18n.locale, slug: article.slug } } : undefined"
          :link="!!article.id"
        >
          <base-img
            :src="article.src"
            :alt="article.title || ''"
            class="mr-4"
            color="grey lighten-1"
            height="72"
            max-width="72"
          />

          <v-list-item-content>
            <v-list-item-subtitle
              class="text-uppercase text-subtitle-2 font-weight-bold text--primary mb-n2"
              v-text="article.title"
            />

            <v-list-item-subtitle
              class="font-weight-bold"
              v-text="article.date"
            />
          </v-list-item-content>
        </v-list-item>

        <v-divider :key="`divider-${i}`" />
      </template>
    </v-list>
  </base-info-card>
</template>

<script>
  export default {
    name: 'NewsRecentArticles',

    data: () => ({
      articles: [],
    }),

    watch: {
      '$i18n.locale'() {
        this.loadRecent()
      },
    },

    async mounted() {
      await this.loadRecent()
    },

    methods: {
      async loadRecent() {
        try {
          const resp = await this.$axios({
            method: 'get',
            url: '/public/blog',
            params: { lang: this.$i18n.locale, page: 1, size: 5 },
          })
          const items = (resp && resp.items) ? resp.items : (resp || [])
          this.articles = items.map(item => ({
            id: item.id,
            date: item.publishAt || '',
            title: item.title || '',
            src: item.coverImage || require('@/assets/logo/logo.png'),
            slug: item.slug || String(item.id || ''),
          }))
        } catch (error) {
          this.articles = []
        }
      },
    },
  }
</script>
